import React from 'react'
import './Popup.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

const Popup = ({ isOpen, onClose=null, children }) => {
    if (!isOpen) return null;
    return (
        <div className="popup-overlay">
            <div className="popup-content" style={{paddingBottom: !onClose && '10px'}}>
                {onClose && <button className="popup-close-button" onClick={onClose}>
                    <FontAwesomeIcon size='xl' icon={faXmark} />
                </button>}
                {children}
            </div>
        </div>
    )
}

export default Popup